import { defaultConfig, plugin } from '@formkit/vue';
import config from '../../formkit.config';
import type { UserModule } from './user-module-type';

// Setup FormKit
// https://formkit.com/
export const install: UserModule = ({ app }) => {
  app.use(plugin, defaultConfig(config));
};
